import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Box } from '../Box';
import { useToast, useToastConfig } from './ToastContext';
import { ToastItem } from './ToastItem';
export var ToastList = function ToastList() {
  var _useToastConfig = useToastConfig(),
      takeContainerWidth = _useToastConfig.takeContainerWidth,
      position = _useToastConfig.position;

  var _useToast = useToast(),
      toasts = _useToast.toasts,
      removeToast = _useToast.removeToast;

  return /*#__PURE__*/React.createElement(Box, {
    "data-test": "toast-list",
    position: position,
    top: 2,
    left: takeContainerWidth ? 2 : 'auto',
    right: 2,
    zIndex: 1009
  }, /*#__PURE__*/React.createElement(AnimatePresence, null, toasts.map(function (toast) {
    return /*#__PURE__*/React.createElement(motion.div, {
      key: toast.id,
      layout: true,
      initial: "hide",
      animate: "show",
      exit: "hide",
      transition: {
        ease: [0, 0, 0, 1],
        duration: 0.3
      },
      variants: {
        hide: {
          opacity: 0,
          y: -50
        },
        show: {
          opacity: 1,
          y: 0
        }
      }
    }, /*#__PURE__*/React.createElement(ToastItem, _extends({}, toast, {
      onDismiss: function onDismiss() {
        return removeToast(toast.id);
      },
      takeContainerWidth: takeContainerWidth
    })));
  })));
};